export const CryptoNames = [
    'ICP',
    'BTC',
    'ETH',
    'BNB',
    'XRP',
    'ADA',
    'SOL',
    'DOGE',
    'DOT',
    'MATIC',
    'TRX',
    'AVAX',
    'ETC',
    'LTC',
    'XLM',
    'XMR',
    'ALGO',
    'BCH',
    'VET',
    'XTZ',
    'AAVE',
    'BSV',
    'ZEC',
    'BTT',
    'NEO',
    'DASH',
    'WAVES',
    'BTG',
    'XEM',
    'DCR',
    'GNO'
] as const;

export type CryptoName = typeof CryptoNames[number];

export const CoinIcons: Record<CryptoName, string> = {
    ICP: new URL('./coin/ICP.png', import.meta.url) + '',
    BTC: new URL('./coin/BTC.png', import.meta.url) + '',
    ETH: new URL('./coin/ETH.png', import.meta.url) + '',
    BNB: new URL('./coin/BNB.png', import.meta.url) + '',
    XRP: new URL('./coin/XRP.png', import.meta.url) + '',
    ADA: new URL('./coin/ADA.png', import.meta.url) + '',
    SOL: new URL('./coin/SOL.png', import.meta.url) + '',
    DOGE: new URL('./coin/DOGE.png', import.meta.url) + '',
    DOT: new URL('./coin/DOT.png', import.meta.url) + '',
    MATIC: new URL('./coin/MATIC.png', import.meta.url) + '',
    TRX: new URL('./coin/TRX.png', import.meta.url) + '',
    AVAX: new URL('./coin/AVAX.png', import.meta.url) + '',
    ETC: new URL('./coin/ETC.png', import.meta.url) + '',
    LTC: new URL('./coin/LTC.png', import.meta.url) + '',
    XLM: new URL('./coin/XLM.png', import.meta.url) + '',
    XMR: new URL('./coin/XMR.png', import.meta.url) + '',
    ALGO: new URL('./coin/ALGO.png', import.meta.url) + '',
    BCH: new URL('./coin/BCH.png', import.meta.url) + '',
    VET: new URL('./coin/VET.png', import.meta.url) + '',
    XTZ: new URL('./coin/XTZ.png', import.meta.url) + '',
    AAVE: new URL('./coin/AAVE.png', import.meta.url) + '',
    BSV: new URL('./coin/BSV.png', import.meta.url) + '',
    ZEC: new URL('./coin/ZEC.png', import.meta.url) + '',
    BTT: new URL('./coin/BTT.png', import.meta.url) + '',
    NEO: new URL('./coin/NEO.png', import.meta.url) + '',
    DASH: new URL('./coin/DASH.png', import.meta.url) + '',
    WAVES: new URL('./coin/WAVES.png', import.meta.url) + '',
    BTG: new URL('./coin/BTG.png', import.meta.url) + '',
    XEM: new URL('./coin/XEM.png', import.meta.url) + '',
    DCR: new URL('./coin/DCR.png', import.meta.url) + '',
    GNO: new URL('./coin/GNO.png', import.meta.url) + ''
};

export const CryptoIcon: React.FC<{ name: string }> = ({ name }) => {
    return <img src={CoinIcons[name]} alt={name} />
}